import { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useUserOrganization } from '@modules-deprecated/app/organization'
import { useCurrentUser } from '@modules-deprecated/app/user'

import { useForm } from '../../../../../../../hooks'
import { useEInvoiceContext } from '../../../context/eInvoiceContext'
import { getDefaultValues, getValidationSchema, RegisterInternationallyForm } from '../utils/formData'

export const useRegisterInternationallyForm = () => {
  const { t } = useTranslation()
  const { organization } = useUserOrganization()
  const { user } = useCurrentUser()
  const { registerInPeppol } = useEInvoiceContext()

  const { handleSubmit, ...form } = useForm({
    defaultValues: useMemo(() => getDefaultValues(organization, user), [organization, user]),
    validationSchema: useMemo(() => getValidationSchema(t), [t]),
  })

  const handleSubmitForm = useCallback(
    (values: RegisterInternationallyForm) => {
      if (!organization?.id) {
        return
      }
      registerInPeppol({ ...values, organizationId: organization.id })
    },
    [organization?.id, registerInPeppol],
  )

  const submitForm = useCallback(() => {
    handleSubmit(handleSubmitForm)()
  }, [handleSubmit, handleSubmitForm])

  return { ...form, submitForm }
}
